import type { MeResponse } from "@repro/shared";
import type { QueryClient } from "@tanstack/react-query";
import { redirect } from "@tanstack/react-router";
import { ApiRequestError } from "../../lib/api-client";
import { meQuery } from "./api";

/** For routes that need a signed-in user: the user, or a redirect to sign in and back. */
export async function requireMe(queryClient: QueryClient, returnTo: string): Promise<MeResponse> {
  try {
    return await queryClient.ensureQueryData(meQuery);
  } catch (error) {
    if (error instanceof ApiRequestError && error.status === 401) {
      throw redirect({ to: "/sign-in", search: { redirect: returnTo } });
    }
    throw error;
  }
}

const SAME_SITE = "http://repro.invalid";

/**
 * Only same-site paths are honoured as a redirect target (no open redirect via ?redirect=). The
 * target is parsed the way a browser would, since browsers read "/\evil.test" as "//evil.test".
 */
export function safeRedirect(value: unknown): string {
  if (typeof value !== "string" || !value.startsWith("/")) return "/";
  const url = new URL(value, SAME_SITE);
  return url.origin === SAME_SITE ? `${url.pathname}${url.search}${url.hash}` : "/";
}
